import moment from 'moment/moment';

export const bannerTimeOutDuration = 2500;

export function toCurrency(number) {
    // let locale = 'en-US';
    // let currencyOptions = { style: 'currency', currency: 'USD' };

    // return (number !== undefined) ? number.toLocaleString(locale, currencyOptions) : "";
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    let result = (number !== undefined) ? USDollar.format(number) : "";
    if(result == "-$0.00") result = "$0.00";
    return result;
    // return (number !== undefined) ? USDollar.format(number) : "";
};

// export function formatNumber(number) {
//     return (number !== undefined) ? number.toLocaleString("en", { minimumFractionDigits: 2 }) : "";
// };

export function formatDate(date) {
    let formattedDate = date ? moment(date, "YYYYMMDD HH:mm:ss.SSS").format("MM/DD/YYYY") : '';
    return formattedDate;
};

export function formatLastUpdateDate(date) {
    let formattedDate = date ? moment.utc(date, "YYYY-MM-DDTHH:mm:ss.SSS").local().format("MM/DD/yyyy HH:mm:ss") : '';
    return formattedDate;
};

export function getDate() {
    const today = new Date();
    let month = today.getMonth() + 1;
    let year = today.getFullYear();
    let date = today.getDate();
    if (date < 10) date = '0' + date;
    if (month < 10) month = '0' + month;

    return `${month}/${date}/${year}`;
  }

// export function formatDateHM(date) {
//     let formattedDate = date ? moment(date, "YYYYMMDD HH:mm:ss.SSS").format("MM/DD/YYYY hh:mm A") : '';
//     return formattedDate;
// };

// export function formatDateDash(date) {
//     let formattedDate = date ? moment(date, "YYYYMMDD HH:mm:ss.SSS").format("YYYY-MM-DD") : '';
//     return formattedDate;
// };

// export function formatDateDashToSlash(date) {
//     let formattedDate = date ? moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") : '';
//     return formattedDate;
// };

// export function getDate() {
//     const today = new Date();
//     let month = today.getMonth() + 1;
//     let year = today.getFullYear();
//     let date = today.getDate();
//     if (date < 10) date = '0' + date;
//     if (month < 10) month = '0' + month;

//     return `${month}-${date}-${year}`;
//   }

// export function getDateYMD() {
// const today = new Date();
// let month = today.getMonth() + 1;
// let year = today.getFullYear();
// let date = today.getDate();
// if (date < 10) date = '0' + date;
// if (month < 10) month = '0' + month;

// return `${year}-${month}-${date}`;
// }

// export function base64ToBlob (base64Data) {
//     // const binaryData = decodeURIComponent(atob(base64Data));
//     const binaryData = atob(base64Data);
//     const arrayBuffer = new ArrayBuffer(binaryData.length);
//     const uint8Array = new Uint8Array(arrayBuffer);
  
//     for (let i = 0; i < binaryData.length; i++) {
//       uint8Array[i] = binaryData.charCodeAt(i);
//     }
  
//     return new Blob([uint8Array], { type: 'application/pdf' });
//   };
